export const PlayIcon = () => {
  return (
    <svg
      data-testid="Icon/Solid/play"
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor" id="Icon/Solid/play">
        <path
          clipRule="evenodd"
          d="M12 21.5999C17.302 21.5999 21.6 17.3018 21.6 11.9999C21.6 6.69797 17.302 2.3999 12 2.3999C6.69809 2.3999 2.40002 6.69797 2.40002 11.9999C2.40002 17.3018 6.69809 21.5999 12 21.5999ZM11.4657 8.60144C11.0974 8.35596 10.624 8.33307 10.2338 8.5419C9.84361 8.75072 9.60002 9.15735 9.60002 9.5999V14.3999C9.60002 14.8425 9.84361 15.2491 10.2338 15.4579C10.624 15.6667 11.0974 15.6439 11.4657 15.3984L15.0657 12.9984C15.3995 12.7758 15.6 12.4011 15.6 11.9999C15.6 11.5987 15.3995 11.224 15.0657 11.0014L11.4657 8.60144Z"
          fill="currentColor"
          fillRule="evenodd"
          id="Icon"
        />
      </g>
    </svg>
  )
}
